export const MAX_SIZE = 10485760; // bytes binary

export const ALLOWED_TYPES = /\.(pdf|doc?x|jpe?g|gif|doc|png)$/i;
